// Server function: mint a short-lived opaque WebSocket token for the current viewer. The browser's
// vibe-socket calls this (via the registered fetcher in start.ts) instead of talking to the builder
// backend. This runs on the app's own Lambda, which is the identity authority: it resolves the
// member (monday session) or guest (viewer id), then asks the DO gateway to mint a token bound to
// that identity using the deploy-time service token. SERVER-ONLY body: '@vibe/db/server' is stripped
// from the client bundle by TanStack Start's server-fn compilation.
import { createServerFn } from '@tanstack/react-start';
import { requestWsToken } from '@vibe/db/server';
import { getCurrentUser } from './current-user.server';

export const getVibeWsToken = createServerFn({ method: 'POST' }).handler(async () => {
  const user = await getCurrentUser();
  if (!user) {
    // No resolvable viewer yet (member: session not delivered; guest: no viewer id). The socket
    // treats a throw as a transient failure and retries with backoff.
    throw new Error('viewer identity not resolved');
  }
  return requestWsToken({
    sub: user.id,
    role: user.kind,
    name: user.name,
    ...(user.photoThumbUrl ? { photoThumb: user.photoThumbUrl } : {}),
  });
});
